/**
 * Andre Garen - Gunduz/Gece modu.
 *
 * Mod tek bir sayidan turer: --ag-p (0 = gece, 1 = gunduz).
 * CSS tum renkleri bu degerden hesaplar, boylece surukleme sirasinda
 * ara tonlar da gecerli olur. Ilk deger <head> icindeki ag-mode-boot
 * betiginde, icerik boyanmadan once atanir.
 */
(function () {
  'use strict';

  var D = document.documentElement;
  var KEY = 'ag:mode';
  var listeners = [];

  function clamp(n, a, b) { return n < a ? a : n > b ? b : n; }

  /** p degerini (0..1) DOM'a yazar. Kalici degil - sadece boyar. */
  function paint(p) {
    p = clamp(p, 0, 1);
    var v = Math.round(p * 255);
    D.style.setProperty('--ag-p', p);
    D.style.setProperty('--ag-v', v);
    D.style.setProperty('--ag-fv', 255 - v);
  }

  /** Modu kesinlestirir, saklar ve dinleyicileri uyarir. */
  function setMode(mode, opts) {
    opts = opts || {};
    mode = mode === 'night' ? 'night' : 'day';
    var prev = D.getAttribute('data-ag-mode');
    D.setAttribute('data-ag-mode', mode);
    paint(mode === 'day' ? 1 : 0);

    if (!opts.transient) {
      try { sessionStorage.setItem(KEY, mode); } catch (e) {}
    }

    document.querySelectorAll('[data-ag-mode-tab]').forEach(function (el) {
      el.setAttribute('aria-current', el.getAttribute('data-ag-mode-tab') === mode ? 'true' : 'false');
    });
    document.querySelectorAll('[data-ag-arc]').forEach(function (el) {
      el.setAttribute('aria-checked', mode === 'night' ? 'true' : 'false');
    });

    if (prev !== mode) {
      listeners.forEach(function (fn) { try { fn(mode); } catch (e) {} });
      document.dispatchEvent(new CustomEvent('ag:mode', { detail: { mode: mode } }));
    }
  }

  function getMode() { return D.getAttribute('data-ag-mode') === 'night' ? 'night' : 'day'; }
  function toggle() { setMode(getMode() === 'day' ? 'night' : 'day'); }

  /* ---------------- suruklenebilir gunes yayi ---------------- */
  function initArc(arc) {
    if (arc.__agInit) return;
    arc.__agInit = true;

    var dragging = false;
    var moved = false;
    var startX = 0;

    function pFromEvent(e) {
      var r = arc.getBoundingClientRect();
      if (!r.width) return null;
      // Yay soldan saga: sol uc = gece (p=0 icin offset %100), sag uc = gunduz.
      // Tasarimda nokta gunduzde solda (%8), gecede sagda (%92) duruyor;
      // dolayisiyla saga surukledikce geceye gidilir.
      var x = clamp((e.clientX - r.left) / r.width, 0, 1);
      return 1 - x;
    }

    arc.addEventListener('pointerdown', function (e) {
      dragging = true;
      moved = false;
      startX = e.clientX;
      arc.setAttribute('data-dragging', '1');
      if (arc.setPointerCapture) { try { arc.setPointerCapture(e.pointerId); } catch (err) {} }
    });

    arc.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      if (Math.abs(e.clientX - startX) > 3) moved = true;
      var p = pFromEvent(e);
      if (p === null) return;
      paint(p);
      // Surukleme sirasinda mod gercek zamanli degissin (henuz kaydetmeden).
      var live = p >= .5 ? 'day' : 'night';
      if (D.getAttribute('data-ag-mode') !== live) {
        D.setAttribute('data-ag-mode', live);
        document.querySelectorAll('[data-ag-mode-tab]').forEach(function (el) {
          el.setAttribute('aria-current', el.getAttribute('data-ag-mode-tab') === live ? 'true' : 'false');
        });
      }
    });

    function release(e) {
      if (!dragging) return;
      dragging = false;
      arc.removeAttribute('data-dragging');
      if (!moved) { toggle(); return; }          // surukleme degil, dokunus
      var p = pFromEvent(e);
      setMode((p === null ? (getMode() === 'day' ? 1 : 0) : p) >= .5 ? 'day' : 'night');
    }

    arc.addEventListener('pointerup', release);
    arc.addEventListener('pointercancel', function () {
      if (!dragging) return;
      dragging = false;
      arc.removeAttribute('data-dragging');
      setMode(getMode());                         // en yakina otur
    });

    arc.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); toggle(); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); setMode('day'); }
      if (e.key === 'ArrowRight') { e.preventDefault(); setMode('night'); }
    });
  }

  function init() {
    document.querySelectorAll('[data-ag-arc]').forEach(initArc);

    document.addEventListener('click', function (e) {
      // Denetim (P0 bug turu): burada onceden e.preventDefault() + setMode()
      // vardi, href'e HIC gidilmiyordu - tab/karta basinca sayfa sadece
      // gunduz/gece renk temasini degistirip GERCEK koleksiyona gitmiyordu.
      // [data-ag-mode-tab] artik yalnizca gercek href'li <a> etiketlerinde
      // kullaniliyor (ag-header.liquid) - setMode() burada SADECE
      // sessionStorage'a modu yazip hedef sayfanin ag-mode-boot.liquid'de
      // doğru modla acilmasini saglamak icin cagriliyor, navigasyonu
      // ENGELLEMIYOR (preventDefault kaldirildi).
      var tab = e.target.closest && e.target.closest('[data-ag-mode-tab]');
      if (tab) { setMode(tab.getAttribute('data-ag-mode-tab')); return; }

      var t = e.target.closest && e.target.closest('[data-ag-mode-toggle]');
      if (t) { e.preventDefault(); toggle(); }
    });

    setMode(getMode(), { transient: true });
  }

  window.AGMode = {
    get: getMode,
    set: setMode,
    toggle: toggle,
    paint: paint,
    onChange: function (fn) { listeners.push(fn); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
